<template>
  <el-card>
    <div class="toolbar">
      <!-- <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增合同
      </el-button> -->
      <el-button type="primary" @click="onImplementationClick()">
        <i class="fa fa-print"></i> 导出实施记录
      </el-button>
      <div class="former">
        <el-input
          v-model="form.Key"
          placeholder="合同编号、名称或签订人"
          @keydown.enter.native="onSubmitQuery"
        ></el-input
        >&nbsp;
        <select2
          v-model="form.ClientID"
          url="client"
          labelName="ClientName"
          placeholder="请选择客户"
          no-data-text="无客户"
          :urlParams="urlParams"
          q="ClientName:like"
          :qinwhere="true"
          :queryOne="false"
        ></select2
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table
      :data="itemList"
      v-loading="loading"
      size="medium"
      tooltip-effect="light"
      style="margin-top: -15px"
    >
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      ></el-table-column>
      <el-table-column
        prop="ContractNumber"
        label="合同编号"
        width="190"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag>
            {{ scope.row.ContractNumber }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="合同名称" align="center">
        <template slot-scope="scope">
          <div>
            {{ scope.row.Name }}
          </div>
          <div>
            <el-tag>
              <el-tooltip content="Top center" placement="top" effect="light">
                <div slot="content">
                  <div>计划销售台数:{{ scope.row.DciSaleNum }} / 实际销售台数:{{ scope.row.DciActSaleNum }}</div>
                </div>
                <i
                  class="fa fa-cart-plus fa-lg"
                  style="cursor: pointer"
                ></i>
              </el-tooltip>
              {{ scope.row.DciSaleNum }} / {{ scope.row.DciActSaleNum }}
            </el-tag>
            <el-tag type="success">
              <el-tooltip content="Top center" placement="top" effect="light">
                <div slot="content">
                  <div>计划现场实施台数:{{ scope.row.DciImplementationNum }} / 实际现场实施台数:{{ scope.row.DciActImplementationNum }}</div>
                </div>
                <i
                  class="fa fa-screwdriver-wrench fa-lg"
                  style="cursor: pointer"
                ></i>
              </el-tooltip>
              {{ scope.row.DciImplementationNum }} / {{ scope.row.DciActImplementationNum }}
            </el-tag>
            <el-tag type="warning">
              <el-tooltip content="Top center" placement="top" effect="light">
                <div slot="content">
                  <div>计划远程实施台数:{{ scope.row.DciImplementationRemoteNum }} / 实际远程实施台数:{{ scope.row.DciActImplementationRemoteNum }}</div>
                </div>
                <i
                  class="fa fa-screwdriver-wrench fa-lg"
                  style="cursor: pointer"
                ></i>
              </el-tooltip>
              {{ scope.row.DciImplementationRemoteNum }} / {{ scope.row.DciActImplementationRemoteNum }}
            </el-tag>
            <el-tag type="danger">
              <el-tooltip content="Top center" placement="top" effect="light">
                <div slot="content">
                  <div>售后现场实施台数:{{ scope.row.DciAfterImplementationNum }} / 售后远程实施台数:{{ scope.row.DciAfterImplementationRemoteNum }}</div>
                </div>
                <i
                  class="fa fa-screwdriver-wrench fa-lg"
                  style="cursor: pointer"
                ></i>
              </el-tooltip>
              {{ scope.row.DciAfterImplementationNum }} / {{ scope.row.DciAfterImplementationRemoteNum }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="合同类型" align="center" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.ContractType">
            {{ scope.row.ContractType.Name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="所属客户" width="250" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.Client">{{ scope.row.Client.ClientName }}</div>
        </template>
      </el-table-column>
      <el-table-column label="业务组分类" align="center" width="95">
        <template slot-scope="{ row }">
          <el-tag
            v-for="(code, index) in row.BusinessGroups"
            :key="index"
            style="margin-right: 5px; color: #00b3ca"
            >{{ getBusinessGroup(code) }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="日期信息" align="center">
        <el-table-column label="签订日期" align="center" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.CheckDay">
              {{ scope.row.CheckDay.substring(0, 10) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="开始/结束日期" align="center" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.ContractStartDay">
              {{ scope.row.ContractStartDay.substring(0, 10) }}
            </div>
            <div v-if="scope.row.ContractEndDay">
              {{ scope.row.ContractEndDay.substring(0, 10) }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column prop="Amount" align="center" label="合同金额" width="100" />
      <!-- <el-table-column prop="ActualAmount" align="center" label="实收金额" width="90" /> -->
      <el-table-column prop="SignName" align="center" label="签订人" width="90" />
      <el-table-column width="90" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <!-- <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      :businessGroupList="businessGroupList"
      @form:saved="getItemList"
    />
    
    <el-dialog
      title="导出实施记录"
      :visible.sync="implementationVisible"
      append-to-body
      :close-on-click-modal="false"
      @close="onClose()"
      width="20%"
    >
      <el-form
        ref="implementationItemForm"
        label-width="120px"
        :model="implementationItem"
        :rules="implementationRules"
      >
        <el-form-item label="年份" prop="Year">
          <el-select
            v-model="implementationItem.Year"
            filterable
            default-first-option
            :clearable="false"
            placeholder="请选择年份"
            style="width: 100%"
          >
            <el-option
              v-for="year in yearList"
              :key="year"
              :label="year"
              :value="year"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onClose()">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onImplementation" :disabled="submitting">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import ItemForm from "./index--form.vue";

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      businessGroupList: [],
      form: {
        Key: "",
        ClientID: "",
        Redirect: false, //记录是不是跳转过合同详情
      },
      item: this.getEmptyItem(),
      itemVisible: false,
      urlParams: { where: {} },
      implementationVisible: false,
      yearList: [],
      implementationItem: {
        Year: "",
      },
      implementationRules: {
        Year: [
          { required: true, message: "统计年份不能为空", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getBusinessGroupList();
    this.getItemList();
    this.getYear();
  },
  created() {
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("search")) {
      var serach = JSON.parse(sessionStorage.getItem("search"));
      if (serach.Redirect) {
        serach.Redirect = false;
        this.form = serach; //JSON.parse(sessionStorage.getItem("search"));
      }
    }

    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("search", JSON.stringify(this.form));
    });
  },
  methods: {
    // 获取
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/contract", {
          params: {
            where: {
              "ContractNumber|Name|SignName:like": this.form.Key,
              ClientID: this.form.ClientID,
              IsVirtually: 0
            },
            BusinessGroups: ["Dci_BusinessGroup"],
            with: ["Client", "Platforms", "ContractType"],
            ...this.pager,
            order: ["-check_day"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getYear() {
      this.yearList = [];
      var day = new Date();
      var year = day.getFullYear();

      for (let index = 0; index < 8; index++) {
        this.yearList.push(year);
        year -= 1;
      }
    },
    //业务组分类
    getBusinessGroupList() {
      this.$axios
        .get("basic", {
          params: {
            type: "BusinessGroup",
          },
        })
        .then((response) => {
          this.businessGroupList = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getBusinessGroup(code) {
      let name = "";
      this.businessGroupList.forEach((item) => {
        if (item.Type === code) {
          name = item.Name;
        }
      });
      return name;
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    // 编辑
    onEditItem(row) {
      this.item = row;
      this.itemVisible = true;
    },
    // 删除
    onDeleteItem(row) {
      this.$confirm("确定要删除此合同吗？", "提示")
        .then(() => this.$axios.delete(`contract/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    // 新增
    onCreateItem() {
      this.item = this.getEmptyItem();      
      this.item.BusinessGroups = ["Dci_BusinessGroup"];
      this.itemVisible = true;
    },
    // item置空
    getEmptyItem() {
      return {
        CheckDay: new Date(),
        ContractStartDay: new Date(),
        Amount: 0,
        ActualAmount: 0,
        IsVirtually: false,
        VirtualStatus: 0,
        DciSaleNum: 0,
        DciImplementationNum: 0,
        DciImplementationRemoteNum: 0,
        DciActImplementationNum: 0,
        DciActImplementationRemoteNum: 0,
        DciAfterImplementationNum: 0,
        DciAfterImplementationRemoteNum: 0,
        QATime: 1,
      };
    },
    // 点击导出实施记录按钮
    onImplementationClick() {
      var day = new Date();
      this.implementationItem.Year = day.getFullYear();
      this.implementationVisible = true;
    },
    onClose() {
      this.$refs.implementationItemForm.resetFields();
      this.implementationVisible = false;
    },
    //导出实施记录
    onImplementation() {
      this.$refs.implementationItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.implementationItem);
        const itemData = { ...this.implementationItem };
        this.$axios
          .post(`contract/dciproducts/print/implementations`, itemData, {
            responseType: "blob", //服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'，默认是'json'
          })
          .then((res) => {
            if (!res) {
              return;
            }
            const blob = new Blob([res.data], {
              type: "application/vnd.ms-excel",
            }); // 构造一个blob对象来处理数据，并设置文件类型

            let fName = "实施记录(" + this.implementationItem.Year + ").xlsx";

            if (window.navigator.msSaveOrOpenBlob) {
              //兼容IE10
              navigator.msSaveBlob(blob, fName);
            } else {
              const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
              const a = document.createElement("a"); //创建a标签
              a.style.display = "none";
              a.href = href; // 指定下载链接
              a.download = fName; //指定下载文件名
              a.click(); //触发下载
              URL.revokeObjectURL(a.href); //释放URL对象

              this.submitting = false;
              this.onClose();
            }
            // 这里也可以不创建a链接，直接window.open(href)也能下载
          })
          .catch((err) => {
            this.submitting = false;
            this.onClose();
            console.log(err);
          });
      });
    },
  },
};
</script>
